// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.html-view-main-box{padding:22px}`, "",{"version":3,"sources":["webpack://./src/screens/app/AppTrainingVideoHTML/style.scss"],"names":[],"mappings":"AAEA,oBACE,YAAA","sourcesContent":["@use '../../../scss/variables' as *;\n\n.html-view-main-box {\n  padding: 22px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
